import { render, staticRenderFns } from "./RankIndex.vue?vue&type=template&id=08646243&scoped=true&"
import script from "./RankIndex.vue?vue&type=script&lang=js&"
export * from "./RankIndex.vue?vue&type=script&lang=js&"
import style0 from "./RankIndex.vue?vue&type=style&index=0&id=08646243&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08646243",
  null
  
)

export default component.exports